module.exports = __webpack_public_path__ + "static/img/menuPelny-ON.17d91103.png";